// extracted by mini-css-extract-plugin
export default {"chip":"keyword_chip-module__chip--61ZPZ","label":"keyword_chip-module__label--1hCFN","selected":"keyword_chip-module__selected--2RPW-","close":"keyword_chip-module__close--12Gn_"};